type Token = {
  id: number
  coinImage: string
  coinName: string
  balance: number
  coin: string
  value: number
}

export const wallets: Token[] = [
  {
    id: 1,
    coinImage: '/assets/tokens/tether.svg',
    coinName: 'Tether (USDT)',
    balance: 754326,
    coin: 'USDT',
    value: 849234,
  },
  {
    id: 2,
    coinImage: '/assets/tokens/ethereum.svg',
    coinName: 'Ethereum (ETH)',
    balance: 504912,
    coin: 'ETH',
    value: 1204932,
  },
  {
    id: 3,
    coinImage: '/assets/tokens/bitcoin.svg',
    coinName: 'Ethereum (ETH)',
    balance: 132576,
    coin: 'USDT',
    value: 145687,
  },
  {
    id: 4,
    coinImage: '/assets/tokens/bitcoin.svg',
    coinName: 'Tether (USDT)',
    balance: 867321,
    coin: 'USDT',
    value: 956432,
  },
  {
    id: 5,
    coinImage: '/assets/tokens/bitcoin.svg',
    coinName: 'Tether (USDT)',
    balance: 324562,
    coin: 'USDT',
    value: 400123,
  },
  {
    id: 6,
    coinImage: '/assets/tokens/bitcoin.svg',
    coinName: 'Bitcoin (BTC)',
    balance: 923401,
    coin: 'BTC',
    value: 1478320,
  },
]
